import {
	getApplicationMakes, getApplicationModels, getApplicationVariants, getApplicationYears,
	getMakes,
	getModels,
	getVariants,
	getYears
} from "../../api/vehicleController";
import { sortBy } from "lodash";

export const fetchMakes = async ({
	yearId,
	setMakeData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await getMakes(yearId);
		if (response.success) {
			setMakeData(response.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchApplicationMakes = async ({
	sku,
	setApplicationMakes,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
    setAuthError
}) => {
	setStatusInProgress();
	try {
		const response = await getApplicationMakes({
			sku
		});
		if (response.success) {
            setApplicationMakes(sortBy(response.data ?? [], x => x.name));
			setStatusSuccess();
            setAuthError(false);
		}
        else if (response.authError) {
            setAuthError(true);
        }
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchModels = async ({
	makeId,
	yearId,
	setModelData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await getModels(makeId, yearId);
		if (response.success) {
			setModelData(sortBy(response.data ?? [], x => x.name));
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchApplicationModels = async ({
	sku,
	makeId,
	setApplicationModels,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
    setAuthError
}) => {
	setStatusInProgress();
	try {
		const response = await getApplicationModels({
			sku,
			makeId
		});
		if (response.success) {
            setApplicationModels(sortBy(response.data ?? [], x => x.name));
			setStatusSuccess();
            setAuthError(false);
        }
        else if (response.authError) {
            setAuthError(true);
        }
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchYears = async ({
	makeId,
	modelId,
	variantId,
	setYearData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await getYears(makeId, modelId, variantId);
		if (response.success) {
			setYearData(response.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchApplicationYears = async ({
	sku,
	makeId,
	modelId,
	variantId,
	setApplicationYears,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
    setAuthError
}) => {
	setStatusInProgress();
	try {
		const response = await getApplicationYears({
			sku,
			makeId,
			modelId,
			variantId
		});
		if (response.success) {
            setApplicationYears(sortBy(response.data ?? [], x => x.name));
			setStatusSuccess();
            setAuthError(false);
        }
        else if (response.authError) {
            setAuthError(true);
        }
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchVariants = async ({
	makeId,
	modelId,
	yearId,
	setVariantData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await getVariants(makeId, modelId, yearId);
		if (response.success) {
			setVariantData(sortBy(response.data ?? [], x => x.name));
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const fetchApplicationVariants = async ({
	sku,
	makeId,
	modelId,
	setApplicationVariants,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
    setAuthError
}) => {
	setStatusInProgress();
	try {
		const response = await getApplicationVariants({
			sku,
			makeId,
			modelId
		});
		if (response.success) {
            setApplicationVariants(sortBy(response.data ?? [], x => x.name));
			setStatusSuccess();
            setAuthError(false);
        }
        else if (response.authError) {
            setAuthError(true);
        }
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};
